"use strict";

module.exports = angular.module(__filename, [
    require('data/filters-partition.srv').name,
    require('./filter-mold-service').name
]).factory("ArticleTypeMold", ['filtersPartition', 'filterMoldService', function (filtersPartition, filterMoldService) {
    return function ArticleTypeMold() {
        this._value = [];
        this.default = [];
        filterMoldService.getDefaultFilterMoldFunction.call(this, filtersPartition.articleType);
    }
}]);
